export default __webpack_public_path__ + "img/icon_lite-796ce0e0653ca6e3b491c0ac02320e26.png";